// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mat-column-positionen {
  width: 40px;
  max-width: 40px;
}

.mat-column-actions {
  width: 180px;
  max-width: 180px;
}`, "",{"version":3,"sources":["webpack://./src/app/util/kalkulation-vorlagen-list/kalkulation-vorlagen-list.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,eAAA;AACF;;AAEA;EACE,YAAA;EACA,gBAAA;AACF","sourcesContent":[".mat-column-positionen {\n  width: 40px;\n  max-width: 40px;\n}\n\n.mat-column-actions {\n  width: 180px;\n  max-width: 180px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
